import React from "react";

/**
 * Error Boundary that wraps the ChatWidget.
 * If the chat widget throws during render, this catches it and
 * renders nothing — the rest of the app stays up.
 */
class ChatWidgetErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("[ChatWidget] Caught render error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      // Render nothing — the main app continues to work
      return null;
    }
    return this.props.children;
  }
}

export default ChatWidgetErrorBoundary;
